<div class="close-icon" mat-button (click)="dialogRef.close()"></div>

<mat-dialog-content style="margin-top: 40px;">
  <p-table [value]="workstreamItems"
           [style]="{'margin-top':'10px'}"
           dataKey="workstreamId"
           #table>

    <ng-template pTemplate="header">
      <tr style="white-space: nowrap;font-weight: bold">
        <th *ngFor="let col of cols">{{col.name}}</th>
      </tr>
      <tr>
        <th *ngFor="let col of cols">
          <input pInputText type="text" placeholder="⌕" (input)="table.filter($event.target['value'], col.field, 'contains')" />
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded">
      <tr class="ui-widget-header"
          *ngIf="rowGroupIndexes[item.workstreamId] === rowIndex">
        <td [attr.colspan]="cols.length">
          <a href="#" [pRowToggler]="item">
            <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
            <span>{{item.workstreamName }}</span>
          </a>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="expandedrow" let-item>
      <tr (click)="select(item)">
        <td *ngFor="let col of cols">{{col['fn'] && item[col.field] ? col['fn'](item[col.field]) : item[col.field]}}</td>
      </tr>
    </ng-template>

  </p-table>
</mat-dialog-content>
